import styled from 'styled-components';

export const GlobalLoadingWrapper = styled.div`
  align-items: center;
  background: var(--k-ds-color-background-alternative, #FFF);
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  padding: 0 1rem;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 99;
`;
